import { createAction } from "redux-starter-kit";

import { NEXT_SIGNUP_STEP } from "../types";

const moveToNextStep = () => createAction(NEXT_SIGNUP_STEP)();

export default moveToNextStep;
